import React, { Component } from 'react';
import { Redirect }         from "react-router-dom";

import Navbar               from './Navbar';
import Project              from './ProjectWithFolders'
import API                  from './server_api'
import { isAuthenticated }  from './Login'


// выводим подряд все проекты
export default class ProjectsList extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            projects: null,
            loading:  true,  // пока еще загружаем список проектов
        };
    }
    
    componentWillMount() {
        // Теперь время загрузить список проектов с сервера
        if ( isAuthenticated() )
            API.getProjectsList( (json)=>{this.setState({ projects: json, loading: false });} );
    }

    render () {
        // неавторизованных пользователей перенаправляем на страницу логина
        if ( !isAuthenticated() )
            return (<Redirect to={{ pathname: "/login", state: { from: this.props.location }}} />);

        let projects = [];
        if ( this.state.projects !== null )
            projects = this.state.projects.map( prj => { return <Project project={prj} key={prj.id}/>; } );

        return ([
            <Navbar key='navbar' />,
            <main key='body' role="main" className="container">
                {projects}
                { this.state.loading || projects.length > 0 ||
                    <center className="p-4">
                        <img className="m-4" src="http://nodelfilms.com/assets/icons/nodelfilms-icon.svg" alt="" width="72" height="72" />
                        <h3 >Вы сейчас не участвуете ни в одном из проектов.</h3>
                        <p>Если это не так, то свяжитесь с нами, чтобы мы настроили Вам права доступа.</p>
                    </center>                
                }
            </main>
        ]);
    }
}
